var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCloseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#fdfcfc"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 17l9.9-9.9M7 7l9.9 9.9",
    stroke: "#525252",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSAiZGF0YTppbWFnZS9zdmcreG1sO2Jhc2U2NCxQSE4yWnlCM2FXUjBhRDBpTmpSd2VDSWdhR1ZwWjJoMFBTSTJOSEI0SWlCMmFXVjNRbTk0UFNJd0lEQWdNalFnTWpRaUlHWnBiR3c5SW01dmJtVWlJSGh0Ykc1elBTSm9kSFJ3T2k4dmQzZDNMbmN6TG05eVp5OHlNREF3TDNOMlp5SWdjM1J5YjJ0bFBTSWpabVJtWTJaaklqNEtJQ0E4WnlCcFpEMGlVMVpIVW1Wd2IxOWlaME5oY25KcFpYSWlJSE4wY205clpTMTNhV1IwYUQwaU1DSStQQzluUGdvZ0lEeG5JR2xrUFNKVFZrZFNaWEJ2WDNSeVlXTmxja05oY25KcFpYSWlJSE4wY205clpTMXNhVzVsWTJGd1BTSnliM1Z1WkNJZ2MzUnliMnRsTFd4cGJtVnFiMmx1UFNKeWIzVnVaQ0krUEM5blBnb2dJRHhuSUdsa1BTSlRWa2RTWlhCdlgybGpiMjVEWVhKeWFXVnlJajRLSUNBZ0lEeHlaV04wSUhkcFpIUm9QU0l5TkNJZ2FHVnBaMmgwUFNJeU5DSWdabWxzYkQwaWQyaHBkR1VpUGp3dmNtVmpkRDRLSUNBZ0lEeHdZWFJvSUdROUlrMDNJREUzVERFMkxqZzVPVFVnTnk0eE1EQTFNU0lnYzNSeWIydGxQU0lqTlRJMU1qVXlJaUJ6ZEhKdmEyVXRiR2x1WldOaGNEMGljbTkxYm1RaUlITjBjbTlyWlMxc2FXNWxhbTlwYmowaWNtOTFibVFpUGp3dmNHRjBhRDRLSUNBZ0lEeHdZWFJvSUdROUlrMDNJRGN1TURBd01ERk1NVFl1T0RrNU5TQXhOaTQ0T1RrMUlpQnpkSEp2YTJVOUlpTTFNalV5TlRJaUlITjBjbTlyWlMxc2FXNWxZMkZ3UFNKeWIzVnVaQ0lnYzNSeWIydGxMV3hwYm1WcWIybHVQU0p5YjNWdVpDSStQQzl3WVhSb1Bnb2dJRHd2Wno0S1BDOXpkbWMrIg==";
export { SvgCloseIcon as ReactComponent };